document.addEventListener('DOMContentLoaded', () => {
  const inputArea = document.getElementById('custom-input-area');
  const hiddenInput = document.getElementById('card-custom-text');
  const charCounter = document.getElementById('custom-input-char-count');
  const errorMessage = document.querySelector('.custom-input-error-message');

  if (!inputArea || !hiddenInput || !charCounter || !errorMessage) return;

  const maxLength = parseInt(inputArea.getAttribute('data-max-length'), 10) || 0;
  if (maxLength <= 0) return;

  const VALID_CHARS = /^[^\p{Cc}]*$/u;

  function getContentLength() {
    return [...inputArea.childNodes].reduce((len, node) => len + (node.length || 1), 0);
  }

  function validate() {
    const textNodes = [...inputArea.childNodes].filter((n) => n.nodeType === Node.TEXT_NODE);
    return textNodes.every((n) => VALID_CHARS.test(n.textContent || ''));
  }

  function update() {
    const length = getContentLength();
    const isValid = validate();

    charCounter.textContent = `${length}/${maxLength}`;
    inputArea.setAttribute('data-length', length);
    inputArea.setAttribute('data-valid', isValid);

    if (isValid) {
      errorMessage.classList.add('hidden');
      inputArea.removeAttribute('aria-invalid');
    } else {
      errorMessage.classList.remove('hidden');
      inputArea.setAttribute('aria-invalid', 'true');
    }

    // Build hidden input value: text as-is, images by alt/data-external-id
    const value = [...inputArea.childNodes]
      .map((node) => {
        return (node.textContent || '').replace(/\|/g, '\\|');
      })
      .join('|');

    hiddenInput.value = value;

    // Toggle submit buttons
    const buttons = document.querySelectorAll(
      '.product-purchase-form [type="submit"], .product-area__add-to-cart-xs button'
    );
    const disabled = length === 0 || !isValid;
    buttons.forEach((btn) => btn.toggleAttribute('disabled', disabled));
  }

  // Prevent input exceeding max length
  inputArea.addEventListener('beforeinput', (e) => {
    if (e.inputType.startsWith('insert') && e.data) {
      if (getContentLength() + e.data.length > maxLength) {
        e.preventDefault();
      }
    }
  });

  inputArea.addEventListener('input', update);

  // Prevent newlines
  inputArea.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') e.preventDefault();
  });

  // Initialize
  update();
});
